import { checkRoleOwned } from '../../lib/helper';

const SET_EVENT = 'SET_EVENT';
const SET_MESSAGES = 'SET_MESSAGES';
const SET_PARTICIPANTS = 'SET_PARTICIPANTS';
const SET_SELECTED_MESSAGE = 'SET_SELECTED_MESSAGE';
const RESET_STATES = 'RESET_STATES';
const SET_PARTICIPANT = 'SET_PARTICIPANT';

const state = {
	isFetching: true,
	isFetchingEvent: true,
	event: null,
	messages: [],
	participants: [],
	selectedMessage: null,
	isFetchingParticipant: true,
	participant: null,
};

const getters = {
	isFetched: state => !state.isFetching && !state.isFetchingEvent,
	isFetching: state => state.isFetching,
	isFetchingEvent: state => state.isFetchingEvent,
	event: state => state.event,
	messages: state => state.messages,
	participants: state => state.participants,
	selectedMessage: state => state.selectedMessage,
	isAdmin: (state, getters) => {
		const roles = getters.participant ? JSON.parse(getters.participant.roles) : [];
		return roles.indexOf('admin') !== -1 || roles.indexOf('moderator') !== -1;
	},
	isDelegate: (state, getters) => !getters.isAdmin,
	isFetchingParticipant: state => state.isFetchingParticipant,
	participant: state => state.participant,
};

const mutations = {
	[RESET_STATES](state) {
		state.event = null;
		state.messages = [];
		state.participants = [];
		state.selectedMessage = null;
	},
	[SET_EVENT](state, event) {
		state.event = event;
	},
	[SET_MESSAGES](state, messages) {
		state.messages = messages;
	},
	[SET_PARTICIPANTS](state, participants) {
		state.participants = participants;
	},
	[SET_SELECTED_MESSAGE](state, message) {
		state.selectedMessage = message;
	},
	[SET_PARTICIPANT](state, participant) {
		state.participant = participant;
	},
	SOCKET_MESSAGES_ADD_LEAVE(state, message) {
		if (state.participant) {
			// Leave recipient
			const isSecretary = checkRoleOwned(state.participant, 'secretary');
			const isModerator = checkRoleOwned(state.participant, 'moderator');
			const isAdmin = checkRoleOwned(state.participant, 'admin');
			const isRoled = (isSecretary || isModerator || isAdmin);
			const isLeave = message.type === 'leave';
			const isCollaborate = isLeave && isRoled;

			// My message
			const isSender = parseInt(message.sender_id) === parseInt(state.participant.id);
			const isRecipient = parseInt(message.recipient_id) === parseInt(state.participant.id);
			const isSentItem = parseInt(message.sender_id) === parseInt(state.participant.id);
			const isDraft = message.status === 'draft';
			const isInbox = isRecipient && !isDraft;
			const isSaveDraft = isSender && isDraft;
			if (isCollaborate || isInbox || isSaveDraft || isSentItem) {
				state.messages.unshift(message);
			}
		}
	},
	SOCKET_MESSAGES_UPDATE(state, message) {
		if (state.messages && state.messages.length > 0) {
			state.messages = state.messages.map((current) => {
				if (parseInt(current.id) === parseInt(message.id)) return Object.assign({}, current, message);
				return current;
			});
		}

		if (state.selectedMessage && state.selectedMessage.id === message.id) {
			state.selectedMessage = message;
		}
	},
	SOCKET_MESSAGES_DELETE(state, messageId) {
		const itemIndex = state.messages.findIndex(curr => parseInt(curr.id) === parseInt(messageId));
		if (itemIndex !== -1) state.messages.splice(itemIndex, 1);
	},
	SOCKET_MESSAGES_BULKDELETE(state, messageIds) {
		if (state.messages && state.messages.length > 0) {
			for (let i = 0; i < messageIds.length; i++) {
				const messageId = messageIds[i];
				for (let j = 0; j < state.messages.length; j++) {
					const current = state.messages[j];
					if (current.id === messageId) {
						state.messages.splice(j, 1);
						break;
					}
				}
			}
		}
	},
	SOCKET_MESSAGES_MARK_AS_READ(state, messages) {
		if (state.messages && state.messages.length > 0) {
			for (let i = 0; i < messages.length; i++) {
				const message = messages[i];
				state.messages = state.messages.map((current) => {
					if (parseInt(current.id) === parseInt(message.id)) return Object.assign({}, current, message);
					return current;
				});
			}
		}
	},
	SOCKET_PARTICIPANTS_UPDATE(state, participant) {
		if (state.participants) {
			const index = state.participants.findIndex(curr => curr.id === participant.id);
			if (index !== -1) Object.assign(state.participants[index], participant);
		}
	},
};

const actions = {
	setEvent({ commit }, data) {
		commit(SET_EVENT, data);
	},
	setParticipants({ commit }, data) {
		commit(SET_PARTICIPANTS, data);
	},
	setParticipant({ commit }, data) {
		commit(SET_PARTICIPANT, data);
	},
	setMessages({ commit }, data) {
		commit(SET_MESSAGES, data);
	},
	setSelectedMessage({ commit }, message) {
		commit(SET_SELECTED_MESSAGE, message);
	},
	resetStates({ commit }) {
		commit(RESET_STATES);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
